import { Block } from "Content/Block";

export const Welcome = () => {
  return (
    <Block caption="Herzlich Willkommen!" captioninblock drawshadow>
      <center>
        <p>Schön, dass du meine Seite besuchst!</p>
        <i>
          <p>
            "Make-up gibt Frauen die Möglichkeit, so auszusehen und sich zu
            fühlen, wie sie sind - nur hübscher und mit mehr Selbstbewusstsein"
          </p>
          <p>-Bobbi Brown-</p>
        </i>
      </center>
    </Block>
  );
};
